export default __webpack_public_path__ + "static/media/ecfa-accredited-seal.fc09f7c2.png";